document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.itinerary'); // Sélection des éléments à afficher

    // Fonction principale appelée après le chargement de l'API Google Maps
    window.initMap = function () {
        console.log('API Google Maps chargée');

        elements.forEach((element) => {
            const coordinates = JSON.parse(element.getAttribute('data-coordinates')); // Données ACF
            const elementId = element.id; // ID de l'élément pour afficher la carte

            if (coordinates.length === 1) {
                // Si une seule coordonnée, afficher un point
                displayPoint(coordinates[0], elementId);
            } else {
                // Si plusieurs coordonnées, afficher un itinéraire
                displayRoute(coordinates, elementId);
            }
        });
    };

    // Fonction pour afficher un point unique sur la carte
    function displayPoint(coord, elementId) {
        const map = new google.maps.Map(document.getElementById(elementId), {
            center: { lat: parseFloat(coord.latitude), lng: parseFloat(coord.longitude) },
            zoom: 12,
        });

        new google.maps.Marker({
            position: { lat: parseFloat(coord.latitude), lng: parseFloat(coord.longitude) },
            map: map,
        });
    }

    // Fonction pour afficher un itinéraire avec plusieurs étapes
    function displayRoute(coordinates, elementId) {
        const map = new google.maps.Map(document.getElementById(elementId), {
            center: { lat: parseFloat(coordinates[0].latitude), lng: parseFloat(coordinates[0].longitude) },
            zoom: 12, // Initial zoom
        });

        const directionsService = new google.maps.DirectionsService();
        const directionsRenderer = new google.maps.DirectionsRenderer({ map: map });

        const waypoints = coordinates.slice(1, coordinates.length - 1).map((coord) => ({
            location: new google.maps.LatLng(parseFloat(coord.latitude), parseFloat(coord.longitude)),
            stopover: true,
        }));

        const bounds = new google.maps.LatLngBounds();

        bounds.extend(new google.maps.LatLng(parseFloat(coordinates[0].latitude), parseFloat(coordinates[0].longitude)));
        bounds.extend(new google.maps.LatLng(parseFloat(coordinates[coordinates.length - 1].latitude), parseFloat(coordinates[coordinates.length - 1].longitude)));

        waypoints.forEach((waypoint) => {
            bounds.extend(waypoint.location);
        });

        directionsService.route(
            {
                origin: new google.maps.LatLng(parseFloat(coordinates[0].latitude), parseFloat(coordinates[0].longitude)),
                destination: new google.maps.LatLng(
                    parseFloat(coordinates[coordinates.length - 1].latitude),
                    parseFloat(coordinates[coordinates.length - 1].longitude)
                ),
                waypoints: waypoints,
                travelMode: google.maps.TravelMode.DRIVING,
            },
            (response, status) => {
                if (status === 'OK') {
                    directionsRenderer.setDirections(response);
                    map.fitBounds(bounds);
                } else {
                    console.error('Erreur avec Directions API :', status);
                }
            }
        );
    }
});
